'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _fastEquals = require('fast-equals');

var _componentCookie = require('component-cookie');

var _componentCookie2 = _interopRequireDefault(_componentCookie);

var _store = require('store2');

var _store2 = _interopRequireDefault(_store);

var _cmsComponentUtilities = require('@viskan/cms-component-utilities');

var _index = require('../index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /** @jsx dom */


var defaultProps = {
	cookieMaxAge: '90'
};

var handleClose = function handleClose(props) {
	return function () {
		var cookieMaxAge = props.cookieMaxAge,
		    id = props.id,
		    noticeStateSession = props.noticeStateSession,
		    noticeStateStorageMethod = props.noticeStateStorageMethod;


		if (noticeStateStorageMethod === 'cookie') {
			(0, _componentCookie2.default)(_index.NOTICE_COOKIE_NAME + '-' + id, 'true', { path: '/', maxage: cookieMaxAge * 86400000 });
			return;
		}

		var newNotices = [].concat(_toConsumableArray(noticeStateSession), [id]);
		_store2.default.session(_index.NOTICE_LS_KEY, newNotices);
	};
};

var shouldUpdate = function shouldUpdate(_ref, nextProps) {
	var props = _ref.props;
	return !(0, _fastEquals.deepEqual)(props, nextProps);
};

var render = function render(_ref2) {
	var props = _ref2.props;
	var children = props.children,
	    cmsActive = props.cmsActive,
	    id = props.id,
	    noticeStateCookie = props.noticeStateCookie,
	    noticeStateSession = props.noticeStateSession,
	    noticeStateStorageMethod = props.noticeStateStorageMethod,
	    show = props.show;

	var isClosed = noticeStateStorageMethod === 'cookie' ? noticeStateCookie : noticeStateSession.length > 0 && noticeStateSession.includes(id);

	if (!cmsActive && (isClosed || !show)) {
		return (0, _cmsComponentUtilities.createCmsComponent)((0, _magicVirtualElement2.default)('noscript', { 'class': ['CMS-Notice', props.styleClasses.Notice], 'data-style-attr': 'Notice' }), props);
	}

	return (0, _cmsComponentUtilities.createCmsComponent)((0, _magicVirtualElement2.default)(
		'div',
		{ 'class': ['CMS-Notice', props.styleClasses.Notice], 'data-style-attr': 'Notice' },
		(0, _magicVirtualElement2.default)(
			'div',
			{ 'class': ['CMS-Notice-close', props.styleClasses.Notice_Close], 'data-style-attr': 'Notice_Close', onClick: !cmsActive && handleClose(props) },
			(0, _magicVirtualElement2.default)('i', { 'class': 'far fa-times-circle' })
		),
		children
	), props);
};

exports.default = { defaultProps: defaultProps, render: render, shouldUpdate: shouldUpdate };